/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable, Inject } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse
} from '@angular/common/http'
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoaderService } from '../../components/loader/loader.service';
import { Router } from '@angular/router';


@Injectable()//{providedIn: 'root'}

export class InterceptService implements HttpInterceptor {

    constructor(@Inject(LoaderService) private loaderService: LoaderService,
        @Inject(Router) private router: Router) {
        this.loaderService.setRequestCount(0);
    }

    // intercept request and add token
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            withCredentials: true
        });
        let requestCount = this.loaderService.getRequestCount();
        requestCount++;
        const newRequestCount = requestCount;
        this.loaderService.setRequestCount(newRequestCount);
        if (newRequestCount > 0) {
            if (!request.headers.get('hideLoader') && !this.loaderService.getPageLoad()) {
                this.loaderService.showLoader();
            }
        }
        request.headers.delete('hideLoader');


        return next.handle(request)
            .pipe(
                tap(event => {
                    if (event instanceof HttpResponse) {
                        let currentRequestCount = this.loaderService.getRequestCount();
                        if (currentRequestCount > 0) {
                            currentRequestCount--;
                            this.loaderService.setRequestCount(currentRequestCount);
                        }
                        if (currentRequestCount <= 0) {
                            this.loaderService.hideLoader();
                        }
                    }
                }, error => {
                    // http response status code
                    if (error.status == 401 || error.status == 403) {
                        if (this.router.url != '/login') {
                            localStorage.clear();
                            //if (isLogoutBySystem != 'true') {
                                localStorage.setItem('unAuthorizedURL', this.router.url);
                            //}
                        }
                        this.router.navigateByUrl('\login');
                    }
                    this.loaderService.hideLoader();
                    this.loaderService.setRequestCount(0);
                })
            )
    }
}